import React from 'react';

import Header from '../components/header/Header';
import ContactForm from '../components/contact/contact-form/ContactForm';
import Footer from '../components/footer/Footer';

const contact = () => {
    return (
        <div>
            <Header />
            <ContactForm dark={true} />
            <Footer />
        </div>
    );
};

export default contact;


// WEBPACK FOOTER //
// ./src/pages/contact.js